module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gPW1o"))).then(() => parcelRequire('hEqeo'));